import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '250px',
    borderRadius: '8px'
};

interface StaticMapDisplayProps {
    lat: number;
    lng: number;
    label?: string;
}

const StaticMapDisplay: React.FC<StaticMapDisplayProps> = ({ lat, lng, label }) => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || "", // Using env variable
    });

    const position = { lat, lng };

    if (!isLoaded) {
        return <div className="p-3 bg-light text-center rounded border">Loading Map...</div>;
    }

    return (
        <div style={{ position: 'relative' }}>
            {label && (
                <div style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    zIndex: 1,
                    background: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    fontWeight: 600,
                    fontSize: '12px',
                    color: '#333' // Ensure text is visible
                }}>
                    {label}
                </div>
            )}
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={position}
                zoom={14}
                options={{
                    disableDefaultUI: true, // cleaner look
                    gestureHandling: 'none', // prevent dragging/zooming
                }}
            >
                <Marker position={position} />
            </GoogleMap>
        </div>
    );
};

export default StaticMapDisplay;
